export default {
  seatLength: 50,
  seatRounding: 5,
  seatGap: 10,
  middleGap: 100,
  groupMarginTop: 50,
  groupRowWidth: 10 * 4 + 0.8 * 3,
};
